import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import Text from "../ui/Text";

const TabView = ({
  tabs,
  activeTab,
  onTabChange,
  children,
  tabContentColors = {},
}) => {
  // Get the background color for the current active tab
  const getContentBackgroundColor = () => {
    return tabContentColors[activeTab] || "#f9f9f9"; // Default color if none specified
  };

  return (
    <div>
      <Box>
        <Tabs
          value={activeTab}
          onChange={onTabChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "#1890FF",
            },
            "& .MuiTab-root": {
              textTransform: "none",
              minHeight: "48px",
              color: "inherit",
              "&.Mui-selected": {
                "& .MuiBox-root": {
                  "& .MuiSvgIcon-root, & .paragraph3": {
                    color: "#1890FF",
                  },
                },
              },
            },
            "& .MuiTabs-scrollButtons": {
              "&.Mui-disabled": {
                opacity: 0.3,
              },
            },
          }}
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.value}
              label={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  {tab.icon &&
                    React.cloneElement(tab.icon, {
                      sx: {
                        ...tab.icon.props.sx,
                        color: activeTab === tab.value ? "#1890FF" : "inherit",
                      },
                    })}
                  <Text
                    variant="paragraph3"
                    className="paragraph3"
                    sx={{
                      color: activeTab === tab.value ? "#1890FF" : "inherit",
                    }}
                  >
                    {tab.label}
                  </Text>
                </Box>
              }
              value={tab.value}
            />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ backgroundColor: getContentBackgroundColor() }}>
        {children}
      </Box>
    </div>
  );
};

export default TabView;
